export const figLogoUrl: string = './assets/images/fig-logo.svg';